<template>
  <div>
    <div class="col-12 p-0">
      <div>
        <div class="col-12 card-container mt-4 p-3" :class="statusClass">
          <div class="d-flex justify-content-between">
            <div
              v-if="status"
              class="border-right pt-2"
              :class="[
                getStatusClasses,
                {
                  'd-flex flex-column justify-content-between': $slots['extra'],
                  'align-items-center d-flex':
                    !$slots['statusInfo'] && !$slots['extra'],
                },
              ]"
            >
              <div>
                <p
                  class="text-center py-2 px-4 status-pill"
                  :class="[statusClass, { 'mb-0': $slots['extra'] }]"
                >
                  {{ status }}
                </p>
              </div>
              <slot name="statusInfo" />
              <div v-if="$slots['extra']">
                <div
                  class="dot text-center cursor-pointer"
                  :class="getBgIcon(extraExpanded)"
                  @click="extraExpanded = !extraExpanded"
                >
                  <i class="title-icon" :class="getIcon(extraExpanded)" />
                </div>
              </div>
              <div v-if="$slots['dynamicExtra']">
                <div class="green dot text-center cursor-pointer">
                  <i class="fas fa-chevron-down title-icon" />
                </div>
              </div>
            </div>
            <div
              :class="{
                'col-8': $slots['actions'],
                'col-10': !$slots['actions'] || !status,
                'col-12': !status && !$slots['actions'],
              }"
            >
              <slot name="body" />
            </div>
            <div v-if="$slots['actions']" class="col-2 pt-2">
              <slot name="actions" />
            </div>
          </div>
        </div>
        <slot v-if="extraExpanded" name="extra" />
        <slot name="dynamicExtra" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabItemCard',
  props: {
    status: {
      type: String,
      default: () => null,
    },
    statusClass: {
      type: String,
      required: true,
    },
    centerStatus: {
      type: Boolean,
      default: () => false,
    },
    statusColumns: {
      type: Number,
      default: () => 2,
    },
  },
  data() {
    return {
      extraExpanded: false,
      dynamicExtraExpanded: true,
    };
  },
  computed: {
    getStatusClasses() {
      let classes = '';
      if (this.centerStatus) {
        classes += 'd-flex align-items-center justify-content-center pl-0';
      }
      classes += ' col-' + this.statusColumns;
      return classes;
    },
  },
  methods: {
    getIcon(expanded) {
      return expanded ? 'fas fa-chevron-down' : 'fas fa-chevron-right';
    },
    getBgIcon(expanded) {
      return expanded ? 'green' : 'gray';
    },
  },
};
</script>

<style scoped>
.status-pill {
  width: fit-content;
  border-radius: 26px;
  opacity: 1;
  text-align: center;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
}
.status-pill.brown {
  background-color: #d5b89a;
}
.status-pill.yellow {
  background-color: #f8eb7f;
}
.status-pill.pink {
  background-color: #fcc9c8;
}
.status-pill.green {
  background-color: #a3e5b3;
}
.status-pill.violet {
  background-color: #ddb3d7;
}
.status-pill.gray {
  background-color: #e8e8e8;
}
.status-pill.orange {
  background-color: #f8c580;
}
.card-container {
  background-color: #f7f7f7;
  border-radius: 5px;
  border-left-style: solid;
  border-width: 4px;
}
.card-container.gray {
  border-color: #e8e8e8;
}
.card-container.brown {
  border-color: #d5b89a;
}
.card-container.yellow {
  border-color: #f8eb7f;
}
.card-container.pink {
  border-color: #fcc9c8;
}
.card-container.green {
  border-color: #a3e5b3;
}
.card-container.violet {
  border-color: #ddb3d7;
}
.card-container.orange {
  border-color: #f8c580;
}
.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
}
.dropdown-menu {
  margin-top: 1rem;
}

.dropdown-item {
  font: Regular 16px/19px Lato;
}

.dropdown-item i {
  margin-right: 1rem;
}

.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}
.dot {
  box-shadow: 0px 3px 6px #00000029;
  margin: 2px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border-style: solid;
  border-width: 3px;
  border-color: #fff;
  display: inline-block;
}
.dot.green {
  background-color: #2db782;
}
.dot.gray {
  background-color: #3f5b60;
}
.title-icon {
  font-size: 1rem;
  color: #fff;
  margin: 6px;
}
</style>
